import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DropDownFilterSettings, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { SimpleResponse, UserDD } from '../../../models/generic-response.model';
import { MemPolicyViolation, MemPolicyViolationListRequest, MemPolicyViolationResponse, REF_MemFeeType } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-mem-policy-violation-list',
    templateUrl: './mem-policy-violation-list.component.html',
    styleUrls: ['./mem-policy-violation-list.component.css']
})
export class MemPolicyViolationListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    policyViolationListSource: MatTableDataSource<any>;
    policyViolationListDisplayColumns: string[] = [];
    //columns = [{ field: 'totalFeeDueByMember', title: 'Total Fee Due By Member', width: '20' },
    //{ field: 'totalFeePaidByMember', title: 'Total Fee Paid By Member', width: '80' },
    //{ field: 'feeType', title: 'Fee Type', width: '150' },
    //{ field: 'policyViolation', title: 'Policy Violation', width: '150' },
    //{ field: 'feeAmount', title: 'Fee Amount', width: '150' },
    //{ field: 'lateArrivalTime', title: 'Late Arrival Time', width: '40' },
    //{ field: 'feeNotes', title: 'Fee Notes', width: '40' },
    //{ field: 'noPolicyViolationFound', title: 'Policy Violation Found', width: '40' },
    //{ field: 'warningIssued', title: 'Warning Issued', width: '40' },
    //    { field: 'feeDate', title: 'Fee date', width: '40' }];
    columns = [{ field: 'contactName', title: 'Name', width: '20' },
    { field: 'feeType', title: 'Fee Type', width: '150' },
    { field: 'policyViolation', title: 'Policy Violation', width: '150' },
    { field: 'feeAmount', title: 'Fee Amount', width: '150' }, 
    { field: 'feeDate', title: 'Fee date', width: '40' }];
    encryptedUser: string;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    cmSites: CMSite[];
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };
    selectedSiteIDs = [];
    policyViolationForm: FormGroup;
    policyViolationList = [];

    selectedCMSiteID: number = 0;
    clpUsersDD: UserDD[];
    selectedUserID: number = 0;
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    sites: number[];
    users: any[];
    ref_MemFeeType_List: REF_MemFeeType[];
    feeTypeID: number = 0;
    private destroy$ = new Subject<void>();

    constructor(
        private localService: LocalService,
        private membershipService: MembershipService,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private userService: UserService,
        private fb: FormBuilder,
        private clubService: CMClubService,
        private datePipe: DatePipe
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.updateTeamDD(true);
        this.localService.setRouteName("mem-policy-violation-list");
    }

    ngOnInit() {
        this.policyViolationForm = this.preparePolicyViolationForm()

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    preparePolicyViolationForm() {
        return this.fb.group({
            feeNotes: [''],
            lateArrivalTime: [''],
            feeAmount: [''],
            totalFeePaidByMember: [''],
            totalFeeDueByMember: [''],
            noPolicyViolationFound: [''],
            warningIssued: ['']
        })
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData()
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.memPolicyViolation_GetList();
                    this.cLPUserGetListByTeamCode(this.user.cLPCompanyID, this.user?.cLPUserID);
                    this.ref_MemFeeType_List = this.localService.refMem_GetAllResponse.ref_MemFeeType_List;

                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.memPolicyViolation_GetList();
                    this.cLPUserGetListByTeamCode(this.user.cLPCompanyID, this.user?.cLPUserID);
                    this.ref_MemFeeType_List = this.localService.refMem_GetAllResponse.ref_MemFeeType_List;
                }
            }
        })
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    onValueChange(multiSelect: MultiSelectComponent) {
        multiSelect.clearFilter();
        //this.cMContractGetList();
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.cmSites = response?.sites;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_GetList() {
        let memPolicyViolationListRequest: MemPolicyViolationListRequest = <MemPolicyViolationListRequest>{};
        memPolicyViolationListRequest.clubId = this.clubConfig?.clubId;
        memPolicyViolationListRequest.dateType = 1;
        memPolicyViolationListRequest.feeTypeID = this.feeTypeID;
        memPolicyViolationListRequest.sites = this.sites;
        memPolicyViolationListRequest.strdtEnd = this.selectedCustomdtEnd;
        memPolicyViolationListRequest.strdtStart = this.selectedCustomdtStart;
        memPolicyViolationListRequest.timeFrame = this.selectedCtDtFilter;
        memPolicyViolationListRequest.users = this.users;

        await this.membershipService.memPolicyViolation_GetList(this.encryptedUser, memPolicyViolationListRequest, 1)
            .then(async (result: MemPolicyViolationResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.policyViolationList = response?.violations;
                    this.setGrid(this.policyViolationList);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Create() {
        let memPolicyViolation: MemPolicyViolation = <MemPolicyViolation>{};
        await this.membershipService.memPolicyViolation_Create(this.encryptedUser, memPolicyViolation)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Update() {
        let memPolicyViolation: MemPolicyViolation = <MemPolicyViolation>{};
        await this.membershipService.memPolicyViolation_Update(this.encryptedUser, memPolicyViolation)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Delete(policyViolationId) {
        await this.membershipService.memPolicyViolation_Delete(this.encryptedUser, policyViolationId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Get(policyViolationId) {
        await this.membershipService.memPolicyViolation_Get(this.encryptedUser, policyViolationId, 0)
            .then(async (result: MemPolicyViolation) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setGrid(list) {
        this.policyViolationListDisplayColumns = this.columns.map(c => c.field);
        this.policyViolationListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.policyViolationListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.policyViolationListSource.sort = this.sort;
            }
        }, 500)

    }

    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(this.selectedUserID);
            await this.memPolicyViolation_GetList();
        }
        else {
            this.users = [];
            await this.memPolicyViolation_GetList();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sites = [];
            this.sites.push(this.selectedCMSiteID);
            await this.memPolicyViolation_GetList();
        }
        else {
            this.sites = [];
            await this.memPolicyViolation_GetList();
        }
    }

    async onChangeStatus() {
        await this.memPolicyViolation_GetList();
    }

    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.memPolicyViolation_GetList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.memPolicyViolation_GetList();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.memPolicyViolation_GetList();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.policyViolationListSource) {
            this.policyViolationListSource.filter = filterValue;
        }
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    selectRow(row: any): void {
        if (!row?.policyViolationID) return;
        const url = `/mem-policy-violation?policyViolationID=${row.policyViolationID}`;
        window.open(url, '_blank');
    }
    navToMemContact(contactID) {
        let url = 'mem-contact/' + contactID;
        window.open(url, '_blank');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
